/**
 * Shell Module - Public API
 * Entry point for all shell/layout components
 *
 * IMPORT FROM HERE, not from internal paths:
 * ✅ import { BlankComponent, FullComponent } from 'src/app/shell';
 * ❌ import { BlankComponent } from 'src/app/shell/layouts/blank/blank.component';
 */

// Layouts
export * from './layouts';
